<template>
  <div class="mb-1 container">
    <div class="picker-container mr-1">
      <type-picker
        v-if="availableTypes.length > 0"
        :availableTypes="availableTypes"
        @type-pick="typePicked"
      ></type-picker>
    </div>
    <div>
      <button
        class="btn btn-primary"
        type="button"
        :disabled="!resolveEnabled"
        @click="resolveClicked"
      >
        Resolve
      </button>
    </div>
  </div>
</template>
<script>
import sharedoTypes from "@/services/sharedo/sharedoTypesService";
import TypePicker from "@/components/common/sharedo/TypePicker.vue";

const loadAvailableTypes = async function () {
  const rootTypes = this.query.query.widgetConfig.options.join(",");
  this.availableTypes = await sharedoTypes.getAll(rootTypes, false);
};

const typePicked = function (args) {
  this.selectedType = args.selectedType;
  this.typeSelector = args.typeSelector;
};

const resolveClicked = function () {
  const args = {};

  if (this.typeSelector === "path") {
    args.path = this.selectedType;
  } else {
    args.type = this.selectedType;
  }

  this.logDebug("Resolving type.", {
    arguments: args,
    fieldQueryName: this.query.name,
  });

  this.$emit("resolve", {
    arguments: args,
    fieldQueryName: this.query.name,
  });
};

export default {
  components: { TypePicker },
  props: {
    field: {
      required: true,
    },
  },
  data: function () {
    return {
      availableTypes: [],
      selectedType: null,
    };
  },
  computed: {
    query: function () {
      return this.field.value.queries.find(
        (q) =>
          q.query.widgetSystemName ===
          "Sharedo.Core.Case.DataGraph.FieldQueries.SharedoTypeSpecifier"
      );
    },
    typeItems: function () {
      return this.availableTypes.map((t) => ({
        label: t.name,
        value: t.systemName,
      }));
    },
    resolveEnabled: function () {
      return !!this.selectedType;
    },
  },
  watch: {
    field: async function (newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        await this.loadAvailableTypes();
      }
    },
  },
  emits: ["resolve"],
  methods: {
    loadAvailableTypes,
    typePicked,
    resolveClicked,
  },
  mounted: async function () {
    await this.loadAvailableTypes();
  },
};
</script>
<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  & > .picker-container {
    flex-grow: 1;
  }
}
</style>
